"use client";
import React from "react";
import { Box, Typography, Button, Grid } from "@mui/material";
import { TextFieldComponent } from "@/components";
import { WEB_COLORS } from "@/lib/constants";

const NewsletterSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#e6f4ec", // light green background
        py: 4,
        px: {
          xs: 4,
          md: 14,
        },
      }}
    >
      <Grid container display={'flex'} alignItems={'center'}>
        <Grid xs={12} md={6}>
          <Typography
            variant="h5"
            fontWeight="bold"
            gutterBottom
            sx={{ fontSize: { xs: 16, md: 34 } }}
          >
            Exclusive Deals
          </Typography>

          <Typography
            variant="body1"
            mb={3}
            color={"#3F3F3FCC"}
            sx={{ fontSize: { xs: 12, md: 16 } }}
          >
            Subscribe to our newsletter and get exclusive deals you won’t find
            anywhere else straight to your inbox!
          </Typography>
        </Grid>
        <Grid xs={12} md={6}>
          <Box
            component="form"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 0,
            }}
            xs={12}
            md={6}
          >
            <TextFieldComponent
              placeholder={"Enter your mail ID"}
              name="email"
              // onBlur={formik.handleBlur}
              // value={formik.values.email}
              // onChange={formik.handleChange}
              // error={Boolean(formik.touched.email && formik.errors.email)}
              // errorMessage={formik.touched.email && formik.errors.email}
            />
            <Button
              variant="contained"
              sx={{
                height: 55,
                backgroundColor: WEB_COLORS.darkTeal,
                color: "#fff",
                px: 4,
                "&:hover": {
                  backgroundColor: "#003024",
                },
              }}
            >
              Subscribe
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NewsletterSection;
